<template>
  <div class="jujuna-bar">
<div class="slidecontainer">
 
  
  <p>1) რამდენი ადამიანი ესწრება ღონისძიებას? :</p>
  <input type="range" min="10" max="50" value="10" class="slider" v-model="guestVal" id="myRange" @input="totalFuncGuest(); totalFuncInt(); yayOrNay();">

   <h2>{{ this.guestVal}}</h2>

  <p>2) რამდენი ხანი გრძელდება ღონისძიება? :</p>
  <input type="range" min="1" max="3" value="1" class="slider" v-model="durVal" id="myRange2" @input="totalFuncGuest(); totalFuncInt(); yayOrNay();">

 <h2>{{ this.durValOutput}}</h2>


  <p>3) რამდენად ინტენსიური იქნება სმა?</p>
  <input type="range" min="1" max="3" value="1" class="slider" v-model="intensity" id="myRange3" @input="totalFuncGuest(); totalFuncInt(); yayOrNay();">
   <h2>{{ this.intensityOutput }}</h2>


  <p>4) იქნება თუ არა ღონისძიებაზე სხვა სასმელიც?</p>
  
 <label class="container">კი
  <input type="radio" v-model="picked" value="კი" name="radio" @change="totalFuncGuest(); totalFuncInt(); yayOrNay();">
  <span class="checkmark"></span>
</label>
 <label class="container">არა
  <input type="radio" v-model="picked" value="არა"  name="radio" @change="totalFuncGuest(); totalFuncInt(); yayOrNay();">
  <span class="checkmark"></span>
</label>

<h2>{{this.picked}}</h2>
  


      <!-- <h2>დრინქები დროის მიხედვით: {{ this.guests}}</h2> -->
      <h2>დრინქები სულ: {{ this.guestsIntensity}}</h2>



<div v-for="(drink, index) in 3" :key="index">
  <p style="margin-top: 100px;">კოექტეილი {{index}}</p>
  <input type="range" min="0" :max="guestsIntensityDup" value="1" class="bottle-slider slider" @input="calcBottles($event)" @change="preventBottles($event)" @click="getOldVal($event)">
  
</div>

  
   


  
   <!-- <h2>ბოთლების ლიმიტი:  {{ this.guestsIntensityDup}}</h2>  -->

</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      guests: 0,
      guestVal: 10,
      durVal: 1,
      durValOutput: 3,
      intensity: 1,
      intensityOutput: 'წრუპვა',
      guestsIntensity: 1,
      picked: 'არა',
      // ============ ბოთლების დათვლა
      //drinkVal: 0,
      guestsIntensityDup: 0,
      sum: [],
      maxBottles: [],
      oldVal: 0,
    };
  },

  mounted() {
    let guests;
   // let guestsRange = document.querySelector("#myRange");
    //let timeRange = document.querySelector("#myRange2");
    // guestsRange.addEventListener("oninput", () => {
    //    guests = guestsRange.value * (timeRange.value * 1.5);
    // })
    //  timeRange.addEventListener("oninput", () => {
    //    guests = guestsRange.value * (timeRange.value * 1.5);
    // })
  

    this.guests = Math.round(this.guestVal * (3 * 1.5));
    this.guestsIntensity = Math.round((this.guestVal * (3 * 1.5)) * 0.7);
    
      let bottles = document.querySelectorAll(".bottle-slider");
     this.guestsIntensityDup = this.guestsIntensity;
     
  },
  computed: {
    total(){
     // this.totalFunc(this.durVal)
    }
  },
  watch: {
    guestsIntensity(){
     // this.guestsIntensity = this.guestsIntensityDup;
    }

  },

  methods: {
  
        totalFuncGuest(){
         // console.log("hey")
      if(this.durVal == 1){
       this.guests = Math.round(this.guestVal * (3 * 1.5));
       this.durValOutput = 3;
      } else if (this.durVal == 2){
       this.guests = Math.round(this.guestVal * (6 * 1.5));
       this.durValOutput = 6;
      }
      else if (this.durVal == 3){
        this.guests = Math.round(this.guestVal * (12 * 1.5));
         this.durValOutput = 12;
      }

        
      //console.log(this.guests)
      //return  this.guests;
    },


        totalFuncInt(){
         // console.log("hey")
      if(this.intensity == 1){
      this.guestsIntensity = Math.round(this.guests * 0.7);
       this.intensityOutput = 'წრუპვა';
      } else if (this.intensity == 2){
      this.guestsIntensity = Math.round(this.guests * 1);
       this.intensityOutput = 'მხიარულება';
      }
      else if (this.intensity == 3){
       this.guestsIntensity = Math.round(this.guests * 1.5);
         this.intensityOutput = 'გალეშვა';
      }

        
      console.log(this.guests)
      //return  this.guests;
    },

    yayOrNay(){
      if(this.picked === 'არა'){
        this.guestsIntensity = this.guestsIntensity * 1;
      } else if (this.picked === 'კი'){
        this.guestsIntensity = Math.round(this.guestsIntensity * 0.7);
      }
       this.guestsIntensityDup = this.guestsIntensity;
    },

    calcBottles(e){
      let bottles = document.querySelectorAll(".bottle-slider");
      let bottlesInt = [];
     
       let total;
       //let sum;
      bottles.forEach(b => {
       
        let bValue = parseInt(b.value);
        bottlesInt.push(bValue);
        //this.guestsIntensityDup = this.guestsIntensityDup - bValue;
       //console.log(this.guestsIntensityDup )
                 //console.log(total)
                 //console.log(this.guestsIntensityDup)
               
                 //this.guestsIntensityDup =
                  // console.log(bValue)
                 b.disabled = false;

      })
     this.sum = bottlesInt.reduce(function(result,item) {
        return result + item;
        }, 0);

      //  console.log(`დარჩენილია: ${this.guestsIntensity - this.sum}`)
      //  console.log(`დარჩენილია: ${this.guestsIntensity - this.sum}`)
      
          // if(sum + 1 > this.guestsIntensityDup){
          //          console.log("limit")
          //         bottles.forEach(bt => {
          //          // bt.disabled = true;
          //          //this.guestsIntensityDup = parseInt(bt.value);
                   
          //   })
            
          //        }
            if(this.sum + 1 > this.guestsIntensity){
                   //console.log(e.target.value)
                  bottles.forEach(bt => {
                  //  bt.disabled = true;
                  //  bt.disabled = false;
                   //bt.value = this.sum;
                   //this.sum = this.guestsIntensity;
                 //  console.log(e.target)

                   bt.disabled = true;
                   e.target.disabled = false;
                   
                   bt.disabled = false;
                    
                   if(this.sum > this.guestsIntensity){
                 // e.target.value = this.oldVal;
                  // bt.setAttribute("max", `${}` )
                   }
              
                   
            })
            
                 }
                  if(this.guestsIntensity - this.sum == 0){ 
                    this.maxBottles = []; 
                      bottles.forEach(b => {

                        let bValue = parseInt(b.value);
                 this.maxBottles.push(bValue);
     
    

                 })
                            // console.log(maxBottles)
                            // console.log(bottles[0].value)
                  
                  }

                    // console.log('max' + this.maxBottles)

                  if(this.guestsIntensity - this.sum < 0){ 
                  bottles[0].value = Number(this.maxBottles[0])
                  bottles[1].value = Number(this.maxBottles[1])
                  bottles[2].value = Number(this.maxBottles[2])
                  // console.log('bottle 0' + bottles[0].value)
                //  console.log(typeof maxBottles[2])
                  }

    //console.log(this.sum)
    },

    getOldVal(e){
      // this.oldVal = e.target.value;
      // console.log('the sum' + this.sum)
      //console.log('the oldval' + this.oldVal)
    },
    preventBottles(e){
       let bottles = document.querySelectorAll(".bottle-slider");
          // if(this.sum + 1 > this.guestsIntensity){
          //          console.log("limit")
          //         bottles.forEach(bt => {
          //         //  bt.disabled = true;
          //         //  bt.disabled = false;
          //          //bt.value = this.sum;
          //          this.guestsIntensityDup = this.sum;
          //          //this.guestsIntensityDup = parseInt(bt.value);
                   
          //   })
             if(this.guestsIntensity - this.sum == 0){
         //this.guestsIntensityDup = this.guestsIntensity - this.sum;
        //  this.oldVal = e.target.value;
        //  e.target.value = this.oldVal;
            //this.oldVal = null;
            bottles.forEach(b => {
            
            })
          // e.preventDefault();
          // console.log('old val' + this.oldVal)
         //alert(e.target.value)
       }

        // if(this.guestsIntensity - this.sum < 0){ 
        //  console.log('old val' + this.oldVal)
        //  e.target.value = this.oldVal;
        //  }
          //        }
          //  let oldValue = e.target.value;
          //  let newValue;
          
          //       //alert(oldValue);
          //       newValue = e.target.value;
          //       oldValue = newValue;
          //       //console.log(newValue)
          //       console.log(this.oldVal + 'old val')

                  
                  
    }
    

  }
  }

</script>

<style lang="scss" scoped>
.slidecontainer {
  width: 100%;
}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 25px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: .2s;
  transition: opacity .2s;
}

.slider:hover {
  opacity: 1;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  background: #04AA6D;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  background: #04AA6D;
  cursor: pointer;
}


.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.container .checkmark:after {
 	top: 9px;
	left: 9px;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: white;
}

.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 42px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
